import { BaseTooltip, type BaseTooltipTriggerProps } from "./base-tooltip";

export const RankingTooltip = ({ trigger, triggerClassName }: BaseTooltipTriggerProps = {}) => {
      return (
            <BaseTooltip trigger={trigger} triggerClassName={triggerClassName}>
                  <p>
                        The ranking of the brand in LLM responses
                        <br />
                        where multiple brands are mentioned.
                  </p>
            </BaseTooltip>
      );
};
